var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-14 col-xs-offset-2 col-md-8 col-md-offset-2"},[_c('div',{staticClass:"txt-media__main-content"},[_vm._t("main-content")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-14 col-xs-offset-2 col-md-5 col-md-offset-1"},[_c('div',{staticClass:"sidebar-container"},[_vm._t("sidebar")],2)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a941aef","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TxtMedia.vue
// module id = null
// module chunks = 